module.exports = __webpack_public_path__ + "img/kv.367c6eff.png";